import React from 'react';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  background-color: #333;
  padding: 20px;
  display: flex;
  justify-content: flex-end;
  font-size: 14px;
  `;

const FooterLink = styled.a`
  // margin-left: 10px;
  // color: #fff;
  // text-decoration: none;

  // &:hover {
  //   text-decoration: underline;
  // }

  margin-left: 10px;
  color: #fff;
  text-decoration: none;

  &:hover {
    color: #00ffff;
    transition: all 0.3s;
  }

`;

const Footer = () => {
  return (
    <FooterContainer>
      {/* <FooterLink href="/app/privacy">プライバシーポリシー</FooterLink> */}
      <FooterLink href="https://www.sakusaku27.com//privacy/">プライバシーポリシー</FooterLink>
      <FooterLink href="https://www.sakusaku27.com/contact/">お問い合わせ</FooterLink>
    </FooterContainer>
  );
};

export default Footer;
